var modules_885eb418 = {"container":"PreFooter_module_container__e5e9054e","preFooter":"PreFooter_module_preFooter__e5e9054e","listItem":"PreFooter_module_listItem__e5e9054e","preFooter__group":"PreFooter_module_preFooter__group__e5e9054e","title":"PreFooter_module_title__e5e9054e","groupTitle":"PreFooter_module_groupTitle__e5e9054e","links":"PreFooter_module_links__e5e9054e"};
import "../assets/esm/PreFooter~DKD2XHkq.css";

export { modules_885eb418 as default };
//# sourceMappingURL=PreFooter.module.less.js.map
